// Preserve ?city= when switching language (AJAX filter updates URL via pushState,
// so lang switcher links rendered by PHP don't have the param — fix it on click)
document.querySelectorAll('.language-switcher .dropdown-menu a[href]').forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();
    const cityParam = new URL(window.location.href).searchParams.get('city');
    const target = new URL(link.href);
    if (cityParam) {
      target.searchParams.set('city', cityParam);
    } else {
      target.searchParams.delete('city');
    }
    window.location.href = target.toString();
  });
});

document.querySelector(".investments-ajax-load-more-btn")?.addEventListener("click", async () => {
  const btn = document.querySelector('.investments-ajax-load-more-btn');
  const btnSpinner = btn.querySelector('.spinner-border');
  btnSpinner?.classList.remove('d-none');
  btn.disabled = true;

  try {
    await asyncFetchInvestmentsData();
  } finally {
    btnSpinner?.classList.add('d-none');
    btn.disabled = false;
  }
});

const cityFilterBtnList = document.querySelectorAll('[data-city_filter]');
cityFilterBtnList?.forEach(btn => {
  btn.addEventListener('click', async (e) => {
    e.preventDefault();

    const isActiveFilter = btn.classList.contains('active');
    const cityFilter = isActiveFilter ? '' : btn.dataset.city_filter;

    cityFilterBtnList.forEach(filter => filter.classList.remove('active'));
    if (!isActiveFilter) btn.classList.add('active');

    await asyncFetchInvestmentsData(cityFilter, true);
  });
});

async function asyncFetchInvestmentsData(cityFilter = '', triggeredByFilter = false) {
  const investmentsListContentWrapper = document.querySelector('#investments-list-content-wrapper');
  const investmentsDataContainer = document.querySelector('.investments-data-container');
  const investmentsDataStatusBar = document.querySelector('.investments-data-status-bar');
  const investmentsLoadMoreBtn = document.querySelector('.investments-ajax-load-more-btn');

  const offset = Number(investmentsDataContainer.dataset.offset);
  const limit = Number(investmentsDataContainer.dataset.limit);
  const cityQuery = triggeredByFilter ? cityFilter : investmentsDataContainer.dataset.city_query;

  const currentPropertiesStatus = investmentsDataStatusBar.querySelector('[data-status_properties]').dataset.status_properties;
  const currentInvestmentsStatus = investmentsDataStatusBar.querySelector('[data-status_investments]').dataset.status_investments;

  const fetchParams = new URLSearchParams();
  fetchParams.append('action', investments_ajax.action);
  fetchParams.append('security', investments_ajax.nonce);

  if (!triggeredByFilter) {
    fetchParams.append('offset', offset);
    fetchParams.append('limit', limit);
    fetchParams.append('currentPropertiesStatus', currentPropertiesStatus);
    fetchParams.append('currentInvestmentsStatus', currentInvestmentsStatus);
  }

  if (cityQuery && !fetchParams.has('city')) fetchParams.append('city', cityQuery);

  if (triggeredByFilter && !investmentsListContentWrapper.querySelector('.loading-state-wrapper')) {
    investmentsDataContainer.classList.add('d-none');
    investmentsDataStatusBar.classList.add('d-none');
    investmentsLoadMoreBtn?.classList.add('d-none');
    investmentsListContentWrapper.insertAdjacentHTML('beforeend', investments_ajax.loading_state);
  }

  try {
    const response = await fetch(investments_ajax.ajax_url, {
      method: 'POST',
      body: fetchParams,
    });

    const responseJson = await response.json();

    // if (!result.success) {
    //   throw new Error(result.data?.message || 'Błąd serwera');
    // }

    //converting response string to node elements
    const parser = new DOMParser();
    const htmlData = responseJson.html_data;
    const htmlStatus = responseJson.html_status;
    const newOffset = responseJson.new_offset;
    const hasMore = responseJson.has_more;

    const articles = parser.parseFromString(htmlData, "text/html").body.querySelectorAll('article');

    // Clear data container if we filter data
    if (triggeredByFilter) {
      investmentsDataContainer.innerHTML = '';
    }

    //appending nodes
    for (const article of articles) {
      investmentsDataContainer.appendChild(article);
    }

    const statusPTagContent = htmlStatus ? parser.parseFromString(htmlStatus, 'text/html').body.querySelector('p') : '';

    investmentsDataStatusBar.innerHTML = '';
    if (statusPTagContent) investmentsDataStatusBar.appendChild(statusPTagContent);

    investmentsDataContainer.dataset.offset = newOffset;

    // Show load more button
    if (!hasMore) {
      if (investmentsLoadMoreBtn) investmentsLoadMoreBtn.classList.add('d-none');
    } else {
      if (investmentsLoadMoreBtn) investmentsLoadMoreBtn.classList.remove('d-none');
    }

    // Remove loading state
    const loadingState = investmentsListContentWrapper.querySelector('.loading-state-wrapper')
    if (loadingState) {
      investmentsDataContainer.classList.remove('d-none');
      investmentsDataStatusBar.classList.remove('d-none');
      if (hasMore) investmentsLoadMoreBtn?.classList.remove('d-none');
      loadingState.remove();
    }

    // Update URL
    const currentURL = new URL(window.location.href);
    fetchParams.delete('security');
    fetchParams.delete('action');
    fetchParams.delete('offset');
    fetchParams.delete('limit');
    fetchParams.delete('currentPropertiesStatus');
    fetchParams.delete('currentInvestmentsStatus');
    currentURL.search = fetchParams;

    window.history.pushState({}, '', currentURL);

  } catch (error) {
    console.error('Something went wrong ;-/ \n', error);
  }
}